import { requiredTypeForDownloadReport } from '@epi-constants/downloadReports';
import { IPillData } from '@epi-models/pages/DownloadReports';

export const hasPayrollSelected = (columns: IPillData[]) => {
  return columns.some(
    c =>
      c.isActive && requiredTypeForDownloadReport.find(elem => elem === c.type)
  );
};
